/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Starts_AtInputs */

const en_admin_allocation_form_starts_at = /** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Date`)
};

const de_admin_allocation_form_starts_at = /** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

const es_admin_allocation_form_starts_at = /** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de inicio`)
};

const fr_admin_allocation_form_starts_at = /** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de début`)
};

const nl_admin_allocation_form_starts_at = /** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

/** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */
const it_admin_allocation_form_starts_at = en_admin_allocation_form_starts_at;

/** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_starts_at = en_admin_allocation_form_starts_at;

/** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */
const pl_admin_allocation_form_starts_at = en_admin_allocation_form_starts_at;

/** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */
const hu_admin_allocation_form_starts_at = en_admin_allocation_form_starts_at;

/** @type {(inputs: Admin_Allocation_Form_Starts_AtInputs) => LocalizedString} */
const ro_admin_allocation_form_starts_at = en_admin_allocation_form_starts_at;

/**
* | output |
* | --- |
* | "Start Date" |
*
* @param {Admin_Allocation_Form_Starts_AtInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_starts_at = /** @type {((inputs?: Admin_Allocation_Form_Starts_AtInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Starts_AtInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_starts_at(inputs)
	if (locale === "de") return de_admin_allocation_form_starts_at(inputs)
	if (locale === "es") return es_admin_allocation_form_starts_at(inputs)
	if (locale === "fr") return fr_admin_allocation_form_starts_at(inputs)
	if (locale === "nl") return nl_admin_allocation_form_starts_at(inputs)
	if (locale === "it") return it_admin_allocation_form_starts_at(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_starts_at(inputs)
	if (locale === "pl") return pl_admin_allocation_form_starts_at(inputs)
	if (locale === "hu") return hu_admin_allocation_form_starts_at(inputs)
	return ro_admin_allocation_form_starts_at(inputs)
});
export { admin_allocation_form_starts_at as "admin.allocation_form.starts_at" }